import { useFindPendingMapping } from "~/gen/api/hooks"

export const useFindPendingMappingQuery = () => useFindPendingMapping()
